module.exports = __webpack_public_path__ + "assets/img/2.543f5c40.jpg";